import { forwardRef } from 'react';

import { cn } from '../../lib/utils';
import { Button, type ButtonProps } from './button';

export interface IconButtonProps extends Omit<ButtonProps, 'size' | 'variant'> {
  variant?: ButtonProps['variant'];
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant = 'ghost', ...props }, ref) => (
    <Button
      ref={ref}
      size="icon"
      variant={variant}
      className={cn('h-8 w-8 rounded', className)}
      {...props}
    />
  )
);

IconButton.displayName = 'IconButton';

export { IconButton };
